import React from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useAppSelector } from 'src/utils/Hooks';
import { shouldShowIntercomChat } from 'src/utils/app';

export default function IntercomChat() {
  const user = useAppSelector((state) => state.user);

  if (shouldShowIntercomChat()) {
    Intercom({
      app_id: 'v13o9toh',
      user_id: user?.session?.userId,
      name: `${user?.session?.userMetaData.firstName} ${user?.session?.userMetaData?.lastName}`,
      email: user?.session?.userMetaData.email,
      created_at: user?.lastUpdated
    });
  }

  return null;
}
